module.exports = __webpack_public_path__ + "assets/img/hcpimg33.66d73cfd.png";